import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import CTAButton from "./CTAButton";

const AboutSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="bg-background py-24 md:py-32 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 1 }}
        >
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.05] text-foreground">
            Il lavoro<br />
            fatto bene<br />
            si vede
          </h2>
          <p className="mt-8 text-muted-foreground text-base md:text-lg leading-relaxed font-body max-w-md">
            Tempi chiari, attenzione ai dettagli e pulizia a fine intervento: sono le cose che contano davvero quando cambi infissi o fai un lavoro in ferro.
          </p>
          <CTAButton className="cta-button mt-8 inline-flex hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 60 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 1, delay: 0.2 }}
          className="overflow-hidden rounded-sm"
        >
          <video
            autoPlay
            muted
            loop
            playsInline
            preload="none"
            className="w-full aspect-[4/3] object-cover"
            src="/videos/about-video.mp4"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;